module.exports = __webpack_public_path__ + "static/img/banner.f59b049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/SkyLight/banner.png
// module id = /UTL
// module chunks = 0